import { looseEqual } from './loose-equal'; // Assumes that the first argument is an array

export var looseIndexOf = function looseIndexOf(array, value) {
  for (var i = 0; i < array.length; i++) {
    if (looseEqual(array[i], value)) {
      return i;
    }
  }

  return -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/utils/loose-index-of.js
// module id = k5Hg
// module chunks = 5